import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Link } from 'react-router-dom'
import { ROLES } from '../services/permissionService'

const ReplenishWorkerLanding = () => {
  const { currentUser, userClaims, logout, userPermissions } = useAuth()
  
  // Check if user has ONLY replenish worker role
  const userRoles = userPermissions?.roles || []
  const isReplenishOnly = userRoles.length === 1 && userRoles.includes(ROLES.REPLENISH_WORKER)

  return (
    <div className="min-vh-100 bg-light d-flex align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card shadow-sm border-0">
              <div className="card-body p-5 text-center">
                <div className="mb-4">
                  <i className="fas fa-qrcode display-1 text-primary mb-3"></i>
                </div>
                
                <h2 className="mb-3">Replenish Worker Portal</h2>
                <p className="text-muted mb-4">
                  Welcome, <strong>{currentUser?.email}</strong>!
                </p>
                
                <div className="alert alert-info border-0" role="alert">
                  <h5 className="alert-heading">
                    <i className="fas fa-info-circle me-2"></i>
                    How to Access Machines
                  </h5>
                  <p className="mb-0">
                    To replenish a vending machine, scan the QR code located on or near the machine. 
                    This will give you secure, time-limited access to edit that specific machine's layout.
                  </p>
                </div>

                <div className="row text-start mt-4">
                  <div className="col-12">
                    <h6 className="text-primary mb-3">
                      <i className="fas fa-clipboard-list me-2"></i>
                      Instructions:
                    </h6>
                    <ol className="text-muted">
                      <li className="mb-2">Locate the QR code on the vending machine</li>
                      <li className="mb-2">Use your phone's camera or QR scanner app</li>
                      <li className="mb-2">Scan the QR code to access the machine</li>
                      <li className="mb-2">Make your layout changes using the mobile interface</li>
                      <li className="mb-2">Your session will automatically expire after 30 minutes</li>
                    </ol>
                  </div>
                </div>

                <div className="alert alert-warning border-0 mt-4" role="alert">
                  <small>
                    <i className="fas fa-clock me-2"></i>
                    <strong>Note:</strong> Each QR code session is machine-specific and time-limited for security.
                  </small>
                </div>

                <div className="d-flex gap-3 mt-4">
                  {!isReplenishOnly && (
                    <Link to="/dashboard" className="btn btn-outline-primary flex-fill">
                      <i className="fas fa-tachometer-alt me-2"></i>
                      View Dashboard
                    </Link>
                  )}
                  <button onClick={logout} className={`btn btn-outline-secondary ${isReplenishOnly ? 'w-100' : 'flex-fill'}`}>
                    <i className="fas fa-sign-out-alt me-2"></i>
                    Logout
                  </button>
                </div>

                {userClaims?.customer && (
                  <div className="mt-4 pt-3 border-top">
                    <small className="text-muted">
                      Customer: <strong>{userClaims.customer}</strong>
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReplenishWorkerLanding